<template>
  <div class="messenger-chat-header">
    <div class="messenger-chat-header__info">
      <chat-header-person />
    </div>
    <div class="messenger-chat-header__actions">
      <div class="messenger-chat-actions">
        <div class="messenger-chat-actions__tags">
          <div
            v-if="currentClient.tags && currentClient.tags.length > 0"
            class="flex max-w-48"
          >
            <messenger-tag
              v-for="tag in currentClient.tags"
              :key="tag.slug"
              :tag="tag"
              :no-delete="true"
              :no-actions="true"
              class="mr-1"
            />
          </div>
        </div>
        <div class="messenger-chat-actions__buttons">
          <div class="messenger-buttons">
            <info-button />

            <chat-download-button />

            <add-comment-button />

            <share-button />
          </div>
        </div>
        <div class="messenger-chat-actions__close">
          <close-button />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import MessengerTag from '@/components/MessengerTag.vue'

import ChatHeaderPerson from './ChatHeaderPerson.vue'
import ChatDownloadButton from './header-buttons/ChatDownloadButton.vue'
import AddCommentButton from './header-buttons/AddCommentButton.vue'
import ShareButton from './header-buttons/ShareButton.vue'
import CloseButton from './header-buttons/CloseButton.vue'
import InfoButton from './header-buttons/InfoButton.vue'

export default {
  components: {
    MessengerTag,
    ChatHeaderPerson,
    ChatDownloadButton,
    AddCommentButton,
    ShareButton,
    CloseButton,
    InfoButton
  },

  data () {
    return {

    }
  },

  computed: mapGetters(['currentClient'])
}
</script>
